var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top relative overflow-hidden"},[_c('div',{staticClass:"top-text"},[_vm._v("智慧生物信息库")])])
}]

export { render, staticRenderFns }